import { render, staticRenderFns } from "./documents-loader.vue?vue&type=template&id=5bb71854"
import script from "./documents-loader.vue?vue&type=script&lang=js"
export * from "./documents-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb71854')) {
      api.createRecord('5bb71854', component.options)
    } else {
      api.reload('5bb71854', component.options)
    }
    module.hot.accept("./documents-loader.vue?vue&type=template&id=5bb71854", function () {
      api.rerender('5bb71854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/documents/components/documents-loader.vue"
export default component.exports